import { validSpacingValues } from "@nib-components/theme";
import PropTypes from "prop-types";
export var validOrderedListTypeValues = ["decimal", "lower-alpha", "none"];
export var validUnorderedListTypeValues = ["disc", "circle", "none"];
export var validListPositionValues = ["inside", "outside"];
export var isValidSpacing = function isValidSpacing(value) {
  return value || value === 0;
};
export var validComponentValues = ["p", "em", "strong", "div", "span", "li"];
export var validAlignValues = ["left", "center", "right"];
export var validWeightValues = ["bold", "normal"];
var spacePropType = PropTypes.oneOf(validSpacingValues);
export var spacingPropTypeMap = PropTypes.oneOfType([spacePropType, PropTypes.shape({
  xs: spacePropType,
  sm: spacePropType,
  md: spacePropType,
  lg: spacePropType,
  xl: spacePropType,
  xxl: spacePropType,
  xxxl: spacePropType
})]);